import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectIsMobile } from "selectors/navigator"

import formatterHelper from "helpers/formatter"

import Button from "components/Button/Button"

import styles from "./ProgramActions.css"

function ProgramActions({ onClick, programPrice, text, onScrollBeyondCTA }) {
  const downloadRef = useRef()
  const isMobile = useSelector(selectIsMobile)

  useEffect(() => {
    let isBeyongCTA = undefined
    const handleScroll = () => {
      const scrollTop = downloadRef.current.getBoundingClientRect().top + downloadRef.current.getBoundingClientRect().height
      if (isBeyongCTA !== scrollTop < 0) {
        isBeyongCTA = scrollTop < 0
        onScrollBeyondCTA(isBeyongCTA)
      }
    }

    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)
  }, [])

  const playIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 19.53V4.59482C6.5 4.02469 6.97777 3.5625 7.56712 3.5625C7.76053 3.5625 7.9503 3.61335 8.11615 3.70961L20.9817 11.1772C21.4871 11.4705 21.651 12.1047 21.3478 12.5935C21.2576 12.7388 21.1319 12.8604 20.9817 12.9476L8.11615 20.4152C7.61078 20.7086 6.95529 20.55 6.65207 20.0611C6.55256 19.9007 6.5 19.7171 6.5 19.53Z"
        fill="black"
      />
    </svg>
  )

  const recordIcon = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <ellipse cx="7.00003" cy="6.99999" rx="6.33709" ry="6.17142" fill="#FF0005" />
    </svg>
  )

  const button = (
    <div className={styles.buttonContainer}>
      <Button color={Button.colors.yellowFull} customStyle={styles.watch} icon={playIcon} value={text} onClick={onClick} />
      <Button customStyle={styles.record} icon={recordIcon} value="Enregistrer" onClick={onClick} />
    </div>
  )

  const cta = isMobile ? (
    button
  ) : (
    <div className={styles.desktopButtonContainer}>
      {Boolean(programPrice) && <span className={styles.paidProgramPrice}>{formatterHelper.insertLineBreak(programPrice)}</span>}
      {button}
    </div>
  )

  return (
    <div className={styles.container} ref={downloadRef}>
      {cta}
    </div>
  )
}

ProgramActions.propTypes = {
  onScrollBeyondCTA: PropTypes.func,
  programPrice: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
}

export default ProgramActions
